import { render, staticRenderFns } from "./SeatingCard.vue?vue&type=template&id=6c6dae44&scoped=true&"
import script from "./SeatingCard.vue?vue&type=script&lang=js&"
export * from "./SeatingCard.vue?vue&type=script&lang=js&"
import style0 from "./SeatingCard.vue?vue&type=style&index=0&id=6c6dae44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6dae44",
  null
  
)

export default component.exports